module.exports = __webpack_public_path__ + "img/icon-sign-in2.c70edf39.svg";